<template>
    <div class="layer-container">
        <div class="content-container">
            <div class="left-menu">
                <div class="workspace-menu">
                    <el-menu :router="true" :default-active="activeIndex">
                        <el-menu-item index="/layer/listWorkspace">
                            <i class="el-icon-house"></i>
                            <span>工作区</span>
                        </el-menu-item>
                    </el-menu>
                </div>
                <el-menu class="el-menu-vertical" :router="true" :default-active="activeIndex" :unique-opened="true" @open="openLayerMenu" @close="closeLayerMenu">
                    <el-submenu :index="w.alias+'&id='+w.id" v-for="w in workspaceMenu" :key="w.id">
                        <template slot="title">
                            <i class="el-icon-monitor"></i>
                            <span>{{w.alias}}</span>
                        </template>
                        <el-menu-item :index="'/layer/detailsLayer?l='+item.alias+'&lid='+item.id" v-for="item in w.list" :key="item.id">{{item.alias}}</el-menu-item>
                    </el-submenu>
                </el-menu>
                <div class="other-menu">
                    <el-menu :default-openeds="otherOpeneds" :router="true" :default-active="activeIndex">
                        <el-submenu index="other-1">
                            <template slot="title">
                                <i class="el-icon-upload2"></i>
                                <span>OGC服务</span>
                            </template>
                            <el-menu-item index="/layer/listTMS">TMS</el-menu-item>
                            <el-menu-item index="/layer/listWMS">WMS</el-menu-item>
                        </el-submenu>
                        <el-submenu index="other-2">
                            <template slot="title">
                                <i class="el-icon-c-scale-to-original"></i>
                                <span>REST服务</span>
                            </template>
                            <el-menu-item index="/layer/listREST">REST</el-menu-item>
                        </el-submenu>
                    </el-menu>
                </div>
            </div>
            <div class="right-content">
                <router-view name="contentRouter"></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import { listWorkspaceMenu } from '../../api/layerApi'
export default {
    name: 'Layer',
    components: {},
    data() {
        return {
            otherOpeneds: ['other-1', 'other-2'],
            activeIndex: '',
            workspaceMenu: []
        }
    },
    mounted() {
        if (this.$route.path.search(/Workspace/) != -1) {
            this.activeIndex = '/layer/listWorkspace'
        } else {
            this.activeIndex = this.$route.path
        }
        this.laodWorkspaceMenu()
    },
    beforeDestroy() {
    },
    methods: {
        openLayerMenu(key, keyPath) {
            this.$router.push('/layer/listLayer?type=layer&w=' + key + '&t=' + new Date().getTime())
        },
        closeLayerMenu(key, keyPath) {
            this.$router.push('/layer/listLayer?type=layer&w=' + key + '&t=' + new Date().getTime())
        },
        laodWorkspaceMenu() {
            listWorkspaceMenu().then(res => {
                if (res.data.code == 200) {
                    this.workspaceMenu = res.data.data
                }
            })
        }
    },
    watch: {
        $route(to, from) {
            if (to.path.search(/Workspace/) != -1) {
                this.activeIndex = '/layer/listWorkspace'
            } else {
                this.activeIndex = to.path
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.layer-container {
    background: #f2f2f2;
    height: calc(100vh - 111px);
    .content-container{
        height: 100%;
        margin: auto;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        .right-content{
            width: 100%;
        }
        .left-menu{
            width: 300px;
            .workspace-menu{
                border-top: solid 1px #e6e6e6;
            }
            .other-menu{
                height: 40%;
                background: white;
                border-top: solid 1px #e6e6e6;;
            }
            .el-menu-vertical{
                height: 58%;
                border-top: solid 1px #e6e6e6;
                overflow-y: auto;
                overflow-x: hidden;
            }
        }
    }
}
</style>

